import { render, staticRenderFns } from "./CallScreen.vue?vue&type=template&id=1d59e90d&scoped=true&"
import script from "./CallScreen.vue?vue&type=script&lang=js&"
export * from "./CallScreen.vue?vue&type=script&lang=js&"
import style0 from "./CallScreen.vue?vue&type=style&index=0&id=1d59e90d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59e90d",
  null
  
)

export default component.exports